export const PAYD_URL = process.env.REACT_APP_PAYD_URL || 'http://payd.local';

export const PAYD_API_URL = process.env.REACT_APP_PAYD_API_URL || 'http://api.payd.local/api/v1';

export const PAYD_GRAPHQL_URL = process.env.REACT_APP_PAYD_GRAPHQL_URL || 'http://api.payd.local/graphql';

export const READONLY_MERCHANT = process.env.REACT_APP_READONLY_MERCHANT === 'true' || false;
